import React, {useState} from 'react';
import Box from '@mui/material/Box';
import { TextField, Typography, Button, InputAdornment, IconButton , styled, Modal,MenuItem} from '@mui/material';
import {Link} from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { authModalStyles } from '../../styles/header';
import { arboristAuth, generateCode, forgotPass } from '../../actions/arboristLogin';
import { useNavigate } from "react-router-dom"
import { useDispatch , useSelector} from 'react-redux';
import { CssTextField } from '../../styles/materialComponent';
import Loader from '../common/loader';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  outline:'none',
  borderRadius:2,
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 5,
  pb:8
};

export default function AuthModal() {
  const classes = authModalStyles()

  const dispatch = useDispatch()
  const navigate =  useNavigate()

  const [showPassword, setShowPassword]= useState(false)
  const [showCode, setShowCode] = useState(false)
  const [forgotPassword, setForgotPassword]= useState(false)
  const [codeSent, setCodeSent]= useState(false)
  const {forgotPasswordEmail, loader} = useSelector(({arboristLogin})=>arboristLogin)

  const [data, setData] = useState({
      email:"",
      password:"",
      type:"Arbor"
  })

  const [state, setState] = useState({
    email:"",
  })
  const[state1,setState1]=useState("Arbor");

  const [forgotData, setForgotData] = useState({
    email: forgotPasswordEmail?.email ? forgotPasswordEmail.email : "",
    code:"",
    password:""
  })
  
  const handleChange =(e)=>{
    const {name, value} = e.target
    // console.log(data)
    setData({...data, [name]:value})
  }

  const handleValueChange =(e)=>{
    console.log(e.target.value)
    const {name, value} = e.target
    // console.log(data)
    setState({...state, [name]:value})
  }
  const handleSubmit =(e)=>{
    e.preventDefault()
    dispatch(arboristAuth(data, navigate))
  }

  const toggle=()=>{
    setShowPassword(!showPassword)
  }

  const toggleCode =()=>{
    setShowCode(!showCode)
  }

  const handlePasswordCode = (e)=>{
    e.preventDefault()
    dispatch(generateCode(state,state1))
    setCodeSent(true)
  }
  
  const handleForgotChange =(e)=>{
    console.log(e.target.value)
    const {name, value} = e.target
    // console.log(data)
    setForgotData({...forgotData, [name]:value})
  }

  const handleResetPassword =(e)=>{
    e.preventDefault()
    dispatch(forgotPass(forgotData))
  }

  return (
    
    <Box p={3} className ={classes.loginModal}>
      {!forgotPassword ?
      <>
      <Typography  fontFamily="CormorantBoldItalic" className={classes.loginText}>Login</Typography>
      <CssTextField
          select
          variant="outlined"
          id="custom-css-outlined-input"
          label="Your Type"
          name="type"
          value={data.type}
          onChange={handleChange}
        >
          <MenuItem disabled value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value={"Arbor"}>Arbor</MenuItem>
          <MenuItem value={"Company"}>Company</MenuItem>
      </CssTextField>

      <CssTextField
        variant="outlined"
        id="custom-css-outlined-input"
        label="Email"
        name="email"
        value = {data.email}
        onChange={handleChange}
        InputLabelProps={{
          classes: {
            root: classes.cssLabel,
            focused: classes.cssFocused,
          },
        }}
        fullWidth
      />
      <CssTextField
        variant="outlined"
        id="custom-css-outlined-input"
        fullWidth
        label="Password"
        name="password"
        type={showPassword ? "text" : "password"}
        value={data.password}  
        onChange={handleChange}  
        InputLabelProps={{
          classes: {
            root: classes.cssLabel,
            focused: classes.cssFocused,
          },
        }}   
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
               <IconButton
                 onClick={toggle}
                 edge="end"
               >
                 {showPassword ? <VisibilityIcon />  : <VisibilityOffIcon /> }
               </IconButton>
             </InputAdornment>
          ) 
        }}
      />   
                  
      <Button 
        variant="contained"
        size="large"     
        style={{backgroundColor:"rgb(115 74 153)"}}   
        onClick={handleSubmit}
      >
         {loader ? <Loader size={25}/> : "Login"}
      </Button>
      <Typography className={classes.forgotStyle} onClick={()=>setForgotPassword(true)}>Forgot Password??</Typography>
      </>
      : codeSent ?
      <>
      <CssTextField
      variant="outlined"
      id="custom-css-outlined-input"
      label="Email"
      name="email"
      value = {forgotData.email}
      onChange={handleForgotChange}
      InputLabelProps={{
        classes: {
          root: classes.cssLabel,
          focused: classes.cssFocused,
        },
      }}
      fullWidth
    />
      <CssTextField
      variant="outlined"
      id="custom-css-outlined-input"
      label="Code"
      name="code"
      value = {forgotData.code}
      type={showCode ? "text" : "password"}
      onChange={handleForgotChange}
      InputLabelProps={{
        classes: {
          root: classes.cssLabel,
          focused: classes.cssFocused,
        },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
             <IconButton
               onClick={toggleCode}
               edge="end"
             >
               {showCode ? <VisibilityIcon />  : <VisibilityOffIcon /> }
             </IconButton>
           </InputAdornment>
        ) 
      }}
      fullWidth
    />
    <CssTextField
        variant="outlined"
        id="custom-css-outlined-input"
        fullWidth
        label="New Password"
        name="password"
        type={showPassword ? "text" : "password"}
        value={forgotData.password}  
        onChange={handleForgotChange}  
        InputLabelProps={{
          classes: {
            root: classes.cssLabel,
            focused: classes.cssFocused,
          },
        }}   
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
               <IconButton
                 onClick={toggle}
                 edge="end"
               >
                 {showPassword ? <VisibilityIcon />  : <VisibilityOffIcon /> }
               </IconButton>
             </InputAdornment>
          ) 
        }}
      />  
     <Button 
        variant="contained"
        size="large"     
        style={{backgroundColor:"rgb(115 74 153)"}}   
        onClick={handleResetPassword}
      >
         Reset password
      </Button>
    </>:
    <>
    <CssTextField
          select
          variant="outlined"
          id="custom-css-outlined-input"
          label="Your Type"
          name="type"
          value={state1}
          onChange={(e)=>setState1(e.target.value)}
        >
          <MenuItem value={"Arbor"}>Arbor</MenuItem>
          <MenuItem value={"Company"}>Company</MenuItem>
      </CssTextField>

    <CssTextField
      variant="outlined"
      id="custom-css-outlined-input"
      label="Email"
      name="email"
      value = {state.email}
      onChange={handleValueChange}
      InputLabelProps={{
        classes: {
          root: classes.cssLabel,
          focused: classes.cssFocused,
        },
      }}
      fullWidth
    />
     <Button 
        variant="contained"
        size="large"     
        style={{backgroundColor:"rgb(115 74 153)"}}   
        onClick={handlePasswordCode}
      >
         Request Code
      </Button>
    </>}
    </Box>

  );
}